export default __webpack_public_path__ + "static/media/img_19.35bb68ab.jpg";